export interface CustomerDetailsModel {
  indexNum?: number;
  indexName?: string;
  officeNum?: number;
  officeName?: string;
  activeFlag?: boolean;
  treeType?: boolean | number;
  technicalPhone?: string;
  professionalPhone?: string;
  empDataUpdateType?: EmpDataUpdateEnum;
  requiredDocs?: string[];
  allowNewForm4UpcomingYear?: boolean;
  update90120Event?: boolean;
  ipToCheck?: string;
  titleIdNum?: string;
  titleValue9?: string;
  titleValue21?: string;
  checkEmploymentPeriod?: boolean;
  checkStopWork?: boolean;
  pensionerOfficeType?: PensionerOfficeType;
  displayHealthFund?: boolean;
  enablePhoneUpdates?: boolean;
  displayPartnerImmigrationDate?: boolean;
  hideTaxCreditSection?: boolean;
  deptFilterOnValue3?: boolean;
  sendSmsOnStatusChanged?: boolean;
  sendSmsOnReject?: boolean;
  multipleDeductionFileNumber?: boolean;
  use90116InSearch?: boolean;
  disableHouseNumber?: boolean;
  cellPhoneEventSrc?: string | number;
  cellPhoneFieldNameSrc?: string | number;
  emailEventSrc?: string | number;
  emailFieldNameSrc?: string | number;
  additionalEmpIdSrc?: string;
  insert90016Event?: boolean;
  displayExternalIncomeFlag?: boolean;
  updateAdditionalPositionNums?: boolean;
  cubesStatus?: CubesStatusType;
  activeCubeList?: string[];
  disablePersonalDetails?: boolean;
  disableAddressDetails?: boolean;
  disableExtraInfoDetails?: boolean;
  disablePartnerDetails?: boolean;
  disableChildrenDetails?: boolean;
  compareLockedFields?: boolean;
  settlementNameUse?: boolean;
  oidcOrganisationCode?: string;
  adpG2CustomerName?: string;
  adpG2CustomerEnvironment?: string;
  adpG2CustomerNumber?: number;
  createEventsForIpt?: boolean;
  changesNotificationFlag?: boolean;
}

enum EmpDataUpdateEnum {
  NO_UPDATE_EMP_DATA,
  PAYROLL_UPDATE_EMP_DATA,
  MASKIT_FILE_EMP_DATA,
  ADP_FILE_EMP_DATA
}

enum PensionerOfficeType {
  NOT_PENSIONER_OFFICE,
  PENSIONER_OFFICE,
  MIXED_PENSIONER_OFFICE,
}

export enum CubesStatusType {
  OFF = 0,
  ACTIVE = 1,
  AUTO = 2,
}
